import { payoutCommissionActions } from 'src/store/api/payoutCommission/actions';
import { IInitState } from 'src/store/api/payoutCommission/types';
import { createReducer } from '@reduxjs/toolkit';

const initialState: IInitState = {
  commissions: {},
  commission: {},
};

export const payoutCommissionReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(payoutCommissionActions.getPayoutCommissions.fulfilled, (state, action) => {
      if (!action.payload) {
        return;
      }

      state.commissions = action.payload;
    })
    .addCase(payoutCommissionActions.getPayoutCommission.fulfilled, (state, action) => {
      if (!action.payload) {
        return;
      }

      state.commission = action.payload;
    })
    .addCase(payoutCommissionActions.togglePayoutCommission.fulfilled, (state, action) => {
      if (!state.commissions.content || !action.payload) {
        return;
      }
      const newCommission = action.payload;

      const newCommissions = state.commissions.content.map((commission) => {
        if (commission.id === newCommission.id) {
          return newCommission;
        }
        return commission;
      });

      state.commissions.content = newCommissions;
    }),
);
